<template id="user-information">
    <div class="modal-dialog user-information">
        <div class="modal-content">
            <div class="modal-body">
                <div class="flex flex-col gap-y-5">
                    <div class="row">
                        <div class="col-xs-12">
                            <p>{{ trans('global.no_occupation_popup') }}</p>
                        </div>
                    </div>
                    <form id="user-information-form" ref="user-information-form" method="post" @submit.prevent="save">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6">
                                        <div class="form-group" :class="{ 'has-error' : errors.has('first_name') }">
                                            <label class="control-label" :for="$makeScopedValue('first_name')">{{ trans('global.first_name') }}</label>
                                            <input type="text" class="form-control extra-padding-mobile" :id="$makeScopedValue('first_name')" name="first_name" autocomplete="off" v-model="user.first_name" required>
                                            <span v-show="errors.has('first_name')" class="help-block">{{ errors.first('first_name') }}</span>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-sm-6">
                                        <div class="form-group" :class="{ 'has-error' : errors.has('last_name') }">
                                            <label class="control-label" :for="$makeScopedValue('last_name')">{{ trans('global.last_name') }}</label>
                                            <input type="text" class="form-control extra-padding-mobile" :id="$makeScopedValue('last_name')" name="last_name" autocomplete="off" v-model="user.last_name" required>
                                            <span v-show="errors.has('last_name')" class="help-block">{{ errors.first('last_name') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12">
                                        <div class="form-group" :class="{ 'has-error' : errors.has('occupation') }">
                                            <label class="control-label" :for="$makeScopedValue('occupation-input')">{{ trans('global.occupation') }}</label>
                                            <input type="hidden" name="occupation" v-model="user.occupation" />
                                            <OccupationSelect v-model="user.occupation" :id="$makeScopedValue('occupation-input')" selectstyle="single" :multiple="false" />
                                            <span v-show="errors.has('occupation')" class="help-block">{{ errors.first('occupation') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="flex justify-end gap-x-5">
                                    <ep-button variant="primary" type="submit">{{ trans('global.save') }}</ep-button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import OccupationSelect from '../global/form/OccupationSelect'
    import EpButton from 'Components/global/button/index.vue'
    import { http } from 'App/http'

    export default {
        props: {
            initial_user: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                user: {}
            }
        },

        methods: {
            save() {
                const formData = new FormData(this.$refs['user-information-form'])

                http.post('/app/settings/profile/update-first-last-name-and-occupation', formData)
                    .then(({ data }) => {
                        this.close();
                    })
                    .catch(({ error, errorBag }) => {
                        this.$setErrorBag(errorBag);
                    });
            },

            close() {
                $('#user-information-modal').modal('hide');
            },
        },

        mounted() {
            this.user = this.initial_user

            $('#user-information-modal').modal({
                backdrop: 'static',
                keyboard: false
            })

            $('#user-information-modal').modal('show')
        },

        components: {
            OccupationSelect,
            EpButton,
        }
    }
</script>
